/**
 * Shared report constants used across dailyReport, projectDailyReport, and wasteManagement.
 */

export const WORK_TYPE_OPTIONS = [
  {
    id: "DOCKET",
    label: "Docket",
    value: "DOCKET",
  },
  {
    id: "CONTRACT",
    label: "Contract",
    value: "CONTRACT",
  },
];

export const DAY_NAMES_UPPER = [
  "SUNDAY",
  "MONDAY",
  "TUESDAY",
  "WEDNESDAY",
  "THURSDAY",
  "FRIDAY",
  "SATURDAY",
];
